<template>
	
  <div class="vpay__step" v-loading="loading">

    <VerificationCode
      v-if="recurringPayment.active"
			ref="verificationCode"
			:client-id="$store.getters.client.id"
			:api-url="$store.getters.smsVerificationApiUrl"
			:tint-colour="$store.getters.brandColour"
			:user-phone-number="$store.getters.userPhoneNumber"
      :recurring-payment-phone="recurringPayment.phone"
			scope="v-pay:payment"
			v-model="$store.state.mobileNumber"
			@event="onVerificationCodeEvent"/>
  
      <div v-if="recurringPayment.cancelled" style="font-size: larger; text-align: center;">
        This recurring payment has already been cancelled.
      </div>
  </div>

</template>

<script>

import { VerificationCode } from "./VerificationCode";

  export default {
  
      name: "CancelRecurring",
  
  components: { VerificationCode },
  
  methods: {
    
    onVerificationCodeEvent(e) {
      const nextButton = this.$refs.verificationCode.$el.getElementsByClassName("vpay__next-button")[0];
        this.loading = true;
        if (e.error) {
          this.loading = false;
          this.$errors.show(nextButton, { message: e.error });
        } else {
          if (e.name === "sendCode") {
            this.$store.commit("mobileNumberValidated", e.mobileNumber);
          } else if (e.name === "receiveCode") {
            this.loading = false;
          } else if (e.name === "codeVerified") {
            this.loading = false;
            this.$store.commit("isMobileNumberValidated", true);

            this.axios
              .post(`cancel/${this.recurringPaymentId}`, {
                headers: this.$store.getters.requestHeaders,
              })
              .then((r) => {
                if (r.data.success) {
                  this.$store.commit("displayComponentName", "SuccessCancelRecurring");
                }
              });
          }
        }
    },
    
  },

  created() {
    this.axios
      .get(`recurring_payments/${this.recurringPaymentId}`, {
        headers: this.$store.getters.requestHeaders,
      })
      .then((r) => {
        if (r.data.success) {
          this.$set(this, "recurringPayment", r.data.results[0]);
          this.$store.commit("recurringPaymentResponse", r.data.results[0]);
        }
      });
  },
  
  data() {
    return {
      recurringPaymentId: this.$store.getters.cancelRecurring,
      recurringPayment: {},
      loading: false,
    };
  }
  
  }

</script>

<style>



</style>
